"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _routing = require("@engaging-tech/routing");
var _components = require("@engaging-tech/components");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
/**
 * Links for account routes. This component is **desktop-only**.
 * @package
 */
var AccountLinks = function AccountLinks() {
  var _useNavContext = (0, _useNavContext2["default"])(),
    accountRoutes = _useNavContext.accountRoutes,
    accountRoutesProps = _useNavContext.accountRoutesProps;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, accountRoutes.length > 0 && accountRoutes.map(function (accountRoute) {
    return /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
      to: accountRoute.path
    }, accountRoute.linkProps, {
      key: accountRoute.description
    }), /*#__PURE__*/_react["default"].createElement(_components.Button, (0, _extends2["default"])({
      leadingIcon: accountRoute.icon,
      borderRadius: 99,
      bg: "secondary.1",
      elevation: 0,
      width: "auto",
      height: 34,
      m: 1
    }, accountRoutesProps), /*#__PURE__*/_react["default"].createElement(_components.Text, (0, _extends2["default"])({
      color: "dark.2",
      fontWeight: "500",
      fontFamily: "Centra",
      fontSize: 3,
      ml: 1,
      mr: 1
    }, accountRoutesProps === null || accountRoutesProps === void 0 ? void 0 : accountRoutesProps.textStyle), accountRoute.description)));
  }));
};
var _default = exports["default"] = AccountLinks;